module.exports = __webpack_public_path__ + "static/logo-only-c676086a66bdd10583796f43305ade61.svg";